import { paths } from '@components/app/routes';

export const getClick2PayUrl = (searchParams: URLSearchParams, pathname: string, additionalParams: string = '') => {
    const additionalSearchParams = new URLSearchParams(additionalParams);

    additionalSearchParams.forEach((value, key) => {
        searchParams.set(key, value);
    });

    const path = {
        pathname: `${paths.CLICK_TO_PAY.path}/${pathname}`,
        search: searchParams.toString(),
    };

    return path;
};
